<script>
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';

  import { formData } from '../stores/formDataStore';

  import FormDropdown from '../components/FormDropdown.svelte';
  import ScaleOption from '../components/ScaleOption.svelte';

  import { requiredString, validateInt } from '../utils/validation';

  export let visible;

  const dispatch = createEventDispatcher();

  const hearOpts = [
    'Search engine (i.e Google)',
    'Through a friend/colleague',
    'Social media',
    'Blog or publication',
    'Other',
  ];

  let data = {
    hearAboutUs: { value: '', error: false, validation: requiredString },
    employeeInteraction: { value: '', error: false, validation: validateInt },
    purchaseArrangeEase: { value: '', error: false, validation: validateInt },
    expectationsMet: { value: '', error: false, validation: validateInt },
    repeatBusiness: { value: '', error: false, validation: validateInt },
  };

  let error = false;

  const handleClick = () => {
    error = false;
    Object.keys(data).forEach((key) => {
      const keyData = data[key];
      const valid = keyData.validation(keyData.value);
      if (valid) {
        data = { ...data, [key]: { ...keyData, error: false } };
      } else {
        error = true;
        data = { ...data, [key]: { ...keyData, error: true } };
      }
    });
    if (!error) {
      const newData = {
        hearAboutUs: data.hearAboutUs.value,
        employeeInteraction: data.employeeInteraction.value,
        purchaseArrangeEase: data.purchaseArrangeEase.value,
        expectationsMet: data.expectationsMet.value,
        repeatBusiness: data.repeatBusiness.value,
      };
      formData.updateFormData(newData);
      dispatch('changePage', { page: 'page3' });
    }
  };
</script>

{#if visible}
  <div
    class="feedback-page-2 feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}>
    <h1 class="main-heading mb-default">Performance</h1>
    <FormDropdown
      options={hearOpts}
      placeholder={'How did you hear about us?'}
      error={data.hearAboutUs.error}
      bind:chosenOpt={data.hearAboutUs.value} />
    <ScaleOption
      name="interaction"
      question="How would you rate your interaction with our employees?"
      lowerVal="Poor"
      higherVal="Great"
      error={data.employeeInteraction.error}
      bind:checked={data.employeeInteraction.value} />
    <ScaleOption
      name="purchase"
      question="Was it easy to book our services or purchase equipment?"
      lowerVal="Difficult"
      higherVal="Easy"
      error={data.purchaseArrangeEase.error}
      bind:checked={data.purchaseArrangeEase.value} />
    <ScaleOption
      name="expectations"
      question="Were your expectations met, not met, or exceeded?"
      lowerVal="Unmet"
      higherVal="Exceeded"
      error={data.expectationsMet.error}
      bind:checked={data.expectationsMet.value} />
    <ScaleOption
      name="repeat"
      question="How likely are you to repeat your business with us?"
      lowerVal="Unlikely"
      higherVal="Likely"
      error={data.repeatBusiness.error}
      bind:checked={data.repeatBusiness.value} />
    <button class="btn base bold block centered" on:click={handleClick}>Continue
      Survey</button>
  </div>
{/if}
